let Api = {
	"EMPLOYEE_FINDPAGELIST": "/system/w/employeeInfo/findPageList", //用户列表
    "EMPLOYEE_SAVEORUPDATE": "/system/w/employeeInfo/saveOrUpdate", //用户新增
    "EMPLOYEE_DEL": "/system/w/employeeInfo/del", //用户删除
    "ROLE_GETLIST": "/system/w/admin/role/findAllRoleList", //角色列表
    "ROLE_DEL": "/system/w/employeeInfo/del", //角色删除
    "ROLE_FINDINFO": "/system/w/employeeInfo/findInfo", //角色查询
    "EMPLOYEEINFO_RESETPWD": "/system/w/employeeInfo/resetPwd", //重置密码
    
    

    "ROLE_FINDROLEPAGE": "/system/w/admin/role/findRolePage", // 角色管理列表
	"ROLE_DELROLEINFO": "/system/w/admin/role/delRoleInfo", //删除角色信息
	"ROLE_SAVEORUPD": "/system/w/admin/role/saveOrUpd", // 新增或者修改角色信息
	"ROLE_FINDALLROLELIST": "/system/w/admin/role/findAllRoleList", //查询当前平台的角色列表
	"ROLE_ROLEMEMBLIST": "/system/w/admin/role/roleMembList", // 查看角色成员
	"ROLE_MENU_LIST": "/system/w/admin/role/menu/list", //获取菜单列表(新增修改角色菜单列表)
	"ROLE_GETDETAIL": "/system/w/admin/role/getDetail", //根据ID查询角色详细信息
    
  "BASE_FINDPAGELIST": "/difam/w/entpBaseMage/findPageList", //基地列表

  
  "PLATINFOMAGE_FINDINFO": "/system/w/PlatInfoMage/findInfo", //查询产业小程序图片管理
  "PLATINFOMAGE_SAVEORUPDATE": "/system/w/PlatInfoMage/saveOrUpdate", //新增/修改产业小程序图片管理xcxImg
  "PLATCONFIG_FINDPAGELIST": "/system/w/PlatConfig/findPageList", //平台配置管理
  "PLATCONFIG_SAVEORUPDATE": "/system/w/PlatConfig/saveOrUpdate", //平台配置信息
  "PLATCONFIG_FINDALLPLATCONFIG": "/system/n/findAllPlatConfig", //平台配置信息

   "CHATWOOTTEAM_FINDLIST": "/system/w/ChatwootTeam/findList", //查询用户客服团队列表
   "CHATWOOTTEAM_SAVEORUPDATE": "/system/w/ChatwootTeam/saveOrUpdate", //新增/修改用户客服团队
   "CHATWOOTINBOX_FINDLIST": "/system/w/ChatwootInbox/findList", //渠道类型列表
   "EMPLOYEE_FINDALL": "/system/w/employeeInfo/findAll", //员工列表
   "CHATWOOTTEAM_FINDINFO": "/system/w/ChatwootTeam/findInfo", //用户客服团队查询详细信息

  
	
	
}
module.exports = Api